import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { Process } from "@/components/site/Process";
import { Materials } from "@/components/site/Materials";
import { Marquee } from "@/components/site/Marquee";
import { Gallery } from "@/components/site/Gallery";
import { Services } from "@/components/site/Services";
import { Restoration } from "@/components/site/Restoration";
import { About } from "@/components/site/About";
import { Trade } from "@/components/site/Trade";
import { Remnants } from "@/components/site/Remnants";
import { Reviews } from "@/components/site/Reviews";
import { EstimateForm } from "@/components/site/EstimateForm";
import { Footer } from "@/components/site/Footer";
import { MobileBar } from "@/components/site/MobileBar";

function App() {
  return (
    <div className="App bg-[#0B0F17] font-body text-[#F5F0E6]">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-[#CDA85B] focus:px-4 focus:py-2 focus:text-[#0B0F17]">Skip to content</a>
      <SmoothScroll />
      <Nav />
      <main id="main">
        <Hero />
        <TrustBar />
        <Process />
        <Materials />
        <Marquee />
        <Gallery />
        <Services />
        <Restoration />
        <About />
        <Trade />
        <Remnants />
        <Reviews />
        <EstimateForm />
      </main>
      <Footer />
      <MobileBar />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
